import React from 'react';

import LoadingSpinner from 'components/loading_spinner';

import './styles.scss';

export default function FullSizeLoadingSpinner() {
  return (
    <div className="full-size-loading-spinner">
      <LoadingSpinner/>
    </div>
  );
}
